module.exports = __webpack_public_path__ + "static/media/empty-state-promo-art.b346c308.svg";